<template>
  <div>
    <div class="announcement">
      <!-- 公告图标 -->
      <page-title-secondary title="关于我们" />
      <div class="announcement__detail">
        <div class="announcement__detail-title announcement__detail-title--top">关于我们</div>
        <div class="announcement__detail-txt" v-html="content"></div>
        <div v-show="partnerFlag" class="announcement__detail-title">合作伙伴</div>
        <div class="announcement__detail-imgs">
          <div v-for="(item, index) in partnerVoList" :key="index" class="announcement__detail-img-item">
            <img @click="openWin(item)" :src="item.logoUrl" class="announcement__detail-img"/>
          </div>
        </div>
        <div v-show="friendshipFlag" class="announcement__detail-title">友情链接</div>
        <div class="announcement__detail-imgs">
          <div v-for="(item, index) in friendshipLinksVoList" :key="index"  class="announcement__detail-img-item">
             <img @click="openWin(item)" :src="item.logoUrl" class="announcement__detail-img"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageTitleSecondary from '../../components/pages/PageTitleSecondary'

export default {
  name: 'announcementDetail',
  components: { PageTitleSecondary },
  data() {
    return {
      detailData: {},
      title: 'wait.',
      time: '',
      partnerVoList: [],
      friendshipLinksVoList: [],
      content: '',
      friendshipFlag: false,
      partnerFlag : false
    };
  },
  created() {
    // this.axios.get("api/getDetail", this.$route.query.code).then(result => {
    //     this.detailData = result.data.detailData
    // })
  },
  mounted() {
    this.$http
      .post('vul/hsrc/vul/report/services/announcement/au/single', {})
      .then(res => {
        if (res.status === 200 && res.data.data) {
          this.content = this.xssDefend(res.data.data.content || '');
          const response = res.data.data;
          if (response['partnerVoList'] && response['partnerVoList'].length) {
            this.partnerVoList = response['partnerVoList'] || [];
            this.partnerFlag = true;
          }
          if (response['friendshipLinksVoList'] && response['friendshipLinksVoList'].length) {
            this.friendshipLinksVoList = response['friendshipLinksVoList'] || [];
            this.friendshipFlag = true;
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    openWin(item) {
      window.open(item.url, '_blank');
    },
    xssDefend(str) {
      if (typeof str !== 'string') {
        return '';
      }
      let html = window.filterXSS(str, {
        whiteList: {
          table: ['width', 'border', 'align', 'valign'],
          tbody: ['align', 'valign', 'text-align'],
          td: ['width', 'rowspan', 'colspan', 'align', 'valign'],
          tfoot: ['align', 'valign'],
          th: ['width', 'rowspan', 'colspan', 'align', 'valign'],
          thead: ['align', 'valign', 'text-align'],
          tr: ['rowspan', 'align', 'valign', 'text-align'],
          tt: [],
          a: ['target', 'href', 'title'],
          abbr: ['title'],
          address: [],
          area: ['shape', 'coords', 'href', 'alt'],
          article: [],
          aside: [],
          b: [],
          bdi: ['dir'],
          bdo: ['dir'],
          big: [],
          blockquote: ['cite'],
          br: [],
          caption: [],
          center: [],
          cite: [],
          code: [],
          col: ['align', 'valign', 'span', 'width'],
          colgroup: ['align', 'valign', 'span', 'width'],
          dd: [],
          del: ['datetime'],
          details: ['open'],
          div: [],
          dl: [],
          dt: [],
          em: [],
          font: ['color', 'size', 'face'],
          footer: [],
          h1: [],
          h2: [],
          h3: [],
          h4: [],
          h5: [],
          h6: [],
          header: [],
          hr: [],
          i: [],
          img: ['src', 'alt', 'title', 'width', 'height'],
          ins: ['datetime'],
          li: [],
          mark: [],
          nav: [],
          ol: [],
          p: [],
          pre: [],
          s: [],
          section: [],
          small: [],
          span: [],
          sub: [],
          sup: [],
          strong: [],
          u: [],
          ul: [],
          p: ['style'],
          strong: ['style'],
          span: ['style'],
          br: [],
          img: ['style', 'src', 'border', 'width', 'height']
        },
        stripIgnoreTag: true, // 过滤所有非白名单标签的HTML
        stripIgnoreTagBody: ['script', 'iframe'] // script标签较特殊，需要过滤标签中间的内容
      });
      return html;
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../global/variable';
// 20220812界面改版需求新增
.announcement__detail{
  padding-bottom: 245px;
 .pageDetailMinHeight()
}

.announcement__detail-title{
  height:70px;
  line-height: 70px;
  margin-top:30px;
  border-bottom: 1px solid var(--src-color-secondary-light5);
  font-size: var(--src--text-size-large-extra3);
  text-align: center;
  font-weight: var(--src-text-weight-light1);
}

.announcement__detail-title--top{
  margin-top:0;
}

.announcement__detail{
  .pageMaxWidth();
  margin: 0 auto;
}

.announcement__detail-txt{
  margin-top: 20px;
}

/deep/.announcement__detail-txt p{
  font-size: var(--src--text-size-large-extra1);
  color: var(--src-text-color-primary-light1);
  text-align: left;
  line-height: var(--src--text-size-large-extra2);
  font-weight: var(--src-text-weight-light1);
  word-break: break-word;
}

.announcement__detail-imgs{
  display:flex;
  flex-wrap:wrap;
  justify-content: center;
  padding: 0 30px;
  margin-left: -30px;
}


.announcement__detail-img-item{
    width: 316px;
    height: 316px;
    margin:30px 0 0 30px;
    border: 1px solid var(--src-color-secondary-light5);
    cursor: pointer;
}

.announcement__detail-img{
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/aboutUs.vue